import _axios from '@/assets/utils/_axios'
import axios from 'axios'
import { _confirm, _alert, _loading } from '../../assets/utils/utils'
import Router from '@/router'
//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;

export default {
   /*获取订单详情信息*/
  async POST_OrderHotelDetail ({ commit, getters }, orderId) {
      let t = getters.storeInfo.type, url = '', data = {};
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelDetail';
          data.store_id = getters.storeInfo.storeId;
          data.oid = orderId;
          break
        case 3:
          url = '/pc/Hotel/OrderHotelDetail';
          data.store_id = getters.storeInfo.storeId;
          data.oid = orderId;
          break
      }
      let res = await _axios.post(url, data);
      if (res.code === '00000') {
        let resInfo = res.data;
        return resInfo;
      }
  },
  /*修改时·获取酒店房型信息*/
  async POST_HotelsRoomList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelRoomTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEROOMLIST',res.data.list);
      }
  },
  /*修改时·获取酒店会议室信息*/
  async POST_HotelsMeetingList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelMeetingTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEMEETINGLIST',res.data.list);
      }
  },
  /*采购商发布订单*/
  async POST_SendOrderHotel ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SendOrderHotel', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') {
      return res.data
    }
  },
  /*采购商修改订单*/
  async POST_travelPostOrder ({commit, getters }, data) {
    let url=getters.userInfo.type==2?'/pc/Travel/StartEditOrderHotel':'/pc/Hotel/StartEditOrderHotel'
    let res = await _axios.post(url, {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
   /*同意修改订单*/
  async POST_EditOrderHotel ({ dispatch,commit, getters }, {data,successFun}) {
    console.log(data)
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/EndEditOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/EndEditOrderHotel';
          break
    }
    let res = await _axios.post(url, {
        store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
        ...data
    });
    if (res.code === '00000') {
      successFun()
    }
  },
    /*采购商设置代收款*/
  async POST_SetOrderHotelBroker ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SetOrderHotelBroker', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
    //计算订单总金额
  async POST_ComputeOrderHotelPrice ({ commit, getters }, data) {
      const res = await _axios.post('/pc/Visitor/ComputeOrderHotelPrice',data);
      if(res.code=="00000"){
          return res.data.info
      }
  },
}